import { TimerPlusOutlineIcon } from './TimerPlusOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 5068DEF2-6E6D-469B-8770-2540F781A8BF
 * name timer-plus-outline
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-plus-outline.svg
 * tags
 * - Date / Time 
 */
export const TimerAddOutlineIcon = TimerPlusOutlineIcon;
export default TimerAddOutlineIcon